module.exports = __webpack_public_path__ + "img/43.85ac746c.jpg";